
import Api from './api'

export default {
    get: function (email) {

        return Api.get(`/emails/${ email }/type`)
            .then(data => {
                switch (data.provider) {
                    case 'microsoft':
                        return {
                            ...data,
                            provider: 'outlook'
                        }
                    default:
                        return data
                }
            })

    }
}
